<template>
  <tr class="reservation-row">
    <td :width="(1 * 100)/12 + '%'">
      <router-link :to="{ path: `/fleet/reservations/${reservation.uuid}` }">
        <strong>{{ reservation.reservationId }}</strong>
      </router-link>
    </td>
    <td :width="(1 * 100)/12 + '%'">
      <span :class="status.class" class="badge">
        {{ status.text }}
      </span>
    </td>
    <td :width="(2 * 100)/12 + '%'">
      <router-link :to="{ path: `/membership/members/${reservation.Account.uuid}` }">
        {{ reservation.Account.dropdownLabel }}
      </router-link>
    </td>
    <td :width="(1 * 100)/12 + '%'">
      <router-link :to="{ path: `/fleet/vehicles/${reservation.Car.uuid}` }">
        {{ reservation.Car.dropdownLabel }}
      </router-link>
    </td>
    <td :width="(2 * 100)/12 + '%'">
      {{ reservation.Lot.address }}
    </td>
    <td :width="(1 * 100)/12 + '%'">
      {{ reservation.actualCost | to_dollar_amount }}
    </td>
    <td :width="(1 * 100)/12 + '%'">
      {{ reservation.completedStartDate || reservation.startDate | short_date_time_format(reservation.Lot.timezone) }}
    </td>
    <td :width="(1 * 100)/12 + '%'">
      {{ reservation.completedEndDate || reservation.endDate | short_date_time_format(reservation.Lot.timezone) }}
    </td>
    <td :width="(2 * 100)/12 + '%'">
      <dropdown-input label="Car Commands"
        :is-small="true"
        label-icon="fa-wifi"
        v-if="(reservation.started && new Date(reservation.endDate) > new Date() && !reservation.completed) || (!reservation.started && !reservation.cancelled && new Date(reservation.endDate) > new Date())"
        :actions="carCommands"
        :dropright="true"
        @action="executeAction($event, reservation.Car)">
      </dropdown-input>
      <dropdown-input label="Actions"
        :is-small="true"
        label-icon="fa-calendar-alt"
        :actions="reservationActions(reservation, loggedInUser)"
        :dropright="true"
        @action="executeAction($event, reservation)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import moment from 'moment-timezone'
import { mapGetters, mapActions } from 'vuex'
import {
  ADD_RESERVATION_NOTE,
  CREATE_RESERVATION_CHARGE,
  EDIT_RESERVATION,
  CANCEL_RESERVATION,
  RESEND_RESERVATION,
  REFUND_RESERVATION,
  GENERATE_RESERVATION_INVOICE,
  SEND_CANCEL_MESSAGE,
  INSTANT_RESERVATION,
  UNLOCK_CAR,
  LOCK_CAR,
  IGNITION_ON,
  IGNITION_OFF,
  IMMOBILIZE_VEHICLE,
  GPS_LOCATION
} from '@/vuex/types'

export default {
  components: {
    DropdownInput
  },
  name: 'ReservationRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    status () {
      if (this.reservation.completed) {
        if (this.reservation.cancelled) {
          return { class: 'badge-purple', text: 'Completed Early' }
        } else {
          return { class: 'badge-success', text: 'Completed' }
        }
      } else if (this.reservation.started) {
        return { class: 'badge-info', text: 'Started' }
      } else if (this.reservation.cancelled) {
        return { class: 'badge-danger', text: 'Cancelled' }
      } else if (moment(this.reservation.startDate).isAfter(moment())) {
        return { class: 'badge-default', text: 'Upcoming' }
      } else {
        return { class: 'badge-default', text: 'Unused' }
      }
    },
    reservation () {
      return {
        started: false,
        completed: false,
        cancelled: false,
        refunded: false,
        reservationId: 0,
        Account: {},
        Car: {},
        Lot: {},
        DestinationLot: {},
        ...this.object,
        ...this.updatedReservation
      }
    },
    ...mapGetters([
      'reservationActions',
      'carCommands',
      'loggedInUser'
    ])
  },
  data () {
    return {
      updatedReservation: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedReservation = result.updated
    },
    ...mapActions([
      CREATE_RESERVATION_CHARGE,
      ADD_RESERVATION_NOTE,
      RESEND_RESERVATION,
      EDIT_RESERVATION,
      CANCEL_RESERVATION,
      REFUND_RESERVATION,
      GENERATE_RESERVATION_INVOICE,
      SEND_CANCEL_MESSAGE,
      INSTANT_RESERVATION,
      UNLOCK_CAR,
      LOCK_CAR,
      IGNITION_ON,
      IGNITION_OFF,
      IMMOBILIZE_VEHICLE,
      GPS_LOCATION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Reservation.vue